import moment from 'moment';

export const computeEndDate = (date: string | null | undefined): string | undefined =>
  date ? moment.utc(date).set({ hour: 23, minutes: 59, seconds: 0 }).format() : undefined;

export const computeStartDate = (date: string): string =>
  moment.utc(date).set({ hour: 0, minutes: 0, seconds: 0 }).format();
